<template>
  <div id="sveManagement" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>

    <div class="layout-content container-fluid mt-5">
      <b-row class="p-2 pl-4">
        <header-v2
          :title="'Sistema de vigilancia epidemiológico'"
          v-if="user.core_role_id != 18"
        />
        <div class="col-6 mt-5" v-else>
          <h2 style="font-weight: bold">Informes</h2>
        </div>
        <b-col cols="12" class="p-2 mx-auto">
          <div
            class="col-6 mt-5"
            v-if="user.core_role_id == 18 && !loadingFiltro"
          >
            <multiselect
              v-model="Selected_SveDash_Oha"
              @input="Selected_user()"
              :options="SveDash_Oha.data"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Busca por ubicación"
              label="name"
              track-by="name"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length && !isOpen"
                  >{{ values.length }} opciones seleccionadas</span
                >
              </template>
            </multiselect>
          </div>
          <b-col
            md="6"
            class="pt-4"
            v-if="user.core_role_id == 18 && loadingFiltro"
          >
            <OverlayButton
              clase="overlay-md mt-5"
              style="opacity: 0.6"
            ></OverlayButton>
          </b-col>
          <OverlayGeneral v-if="loadingOn"></OverlayGeneral>
          <b-row v-else class="p-2 mx-auto mt-5 align-items-end">
            <b-col md="6" class="pt-4">
              <b-row>
                <b-col md="4">
                  <div class="title-generic">
                    <span class="body_bold"> Tipos de SVE </span>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="subtitle-graphic">
                    <span class="blue"></span>
                    <span class="ml-1 body_bold"> Operativos</span>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="subtitle-graphic">
                    <span class="orange"></span>
                    <span class="ml-1 body_bold">Administrativos</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <div class="title-generic">
                <span class="cta">Áreas de Ges: {{ currentNameSve }} </span>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="6" class="pt-4" v-if="!loadingOn">
          <div
            class="main-types-ges"
            v-for="(SVE, keySVE) in SveDash.data"
            :key="keySVE"
          >
            <ul>
              <li
                @click="VerAreaGes(SVE)"
                style="cursor: pointer"
                class="p-1 pl-2 Selected_area"
                v-bind:class="
                  SVE.name == currentNameSve
                    ? 'Selected_area_hover'
                    : 'Selected_area'
                "
              >
                <div class="title-graphics">
                  <span>
                    {{ SVE.name }}
                  </span>
                </div>
                <div class="types-ges-graphics">
                  <ProgressBar
                    :value-operative="SVE.operative.percent"
                    :message-operative="SVE.operative.message"
                    :value-administrative="SVE.administrative.percent"
                    :message-administrative="SVE.administrative.message"
                  />
                </div>
              </li>
            </ul>
          </div>
        </b-col>
        <b-col md="6" class="pt-4" v-else>
          <OverlayButton
            clase="overlay-md"
            style="opacity: 0.6"
          ></OverlayButton>
        </b-col>
        <b-col md="6">
          <ht-details-area :show="!verarea" :sve-id="SVEtemp.id" />
        </b-col>
        <b-col cols="12">
          <div class="py-4">
            <hr />
          </div>
        </b-col>
        <b-col cols="12">
          <div class="title-generic mb-4">
            Manejo de casos por proceso y áreas
          </div>
          <template>
            <div>
              <b-table
                :items="dataTablePandA.rows"
                :fields="dataTablePandA.fields"
                :busy="loadingPandA"
                select-mode="single"
                class="col-12 mt-2 table-views text-center"
              >
                <template #table-busy>
                  <div class="text-center my-2 mb-3">
                    <OverlayButton
                      clase="overlay-md"
                      opacity="0.6"
                    ></OverlayButton>
                  </div>
                </template>
              </b-table>
              <div v-if="!this.dataTablePandA.rows[0] && !loadingOn">
                <p class="col-12 text-center my-2 cta-small">
                  Sin datos para mostrar.
                </p>
              </div>
            </div>
          </template>
        </b-col>
        <b-col cols="12">
          <div class="py-4">
            <hr />
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="title-generic mb-4">Calificación de GES</div>
            </b-col>
            <b-col md="5">
              <div
                class="doughnut-main-ges"
                v-if="ratingGes.datasets[0].data[0] && !loadingcl"
              >
                <div class="doughnut-chart-ges py-4">
                  <DoughnutChart
                    :chart-data="ratingGes"
                    :options="ChartOptions"
                  />
                  <div class="percentage-chart-ges">
                    {{ this.TotalratingGes }}
                    <span> Total </span>
                  </div>
                </div>
                <div class="doughnut-legend-ges">
                  <ul>
                    <li>
                      <div class="subtitle-graphic">
                        <span class="blue"></span>
                        Operativos
                      </div>
                      <div class="text-graphic">
                        {{ SveDash_cl.data.ges.operative.message }}
                      </div>
                    </li>
                    <li>
                      <div class="subtitle-graphic">
                        <span class="orange"></span>
                        Administrativos
                      </div>
                      <div class="text-graphic">
                        {{ SveDash_cl.data.ges.administrative.message }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="!ratingGes.datasets[0].data[0] && !loadingcl">
                <p class="col-12 text-center my-2 cta-small">
                  Sin datos para mostrar.
                </p>
              </div>
              <div v-if="loadingcl">
                <OverlayButton
                  clase="overlay-md"
                  style="opacity: 0.6"
                ></OverlayButton>
              </div>

              <div class="title-generic mb-4 mt-5">Caracterización del GES</div>
              <div
                class="bar-main-ges"
                v-if="this.suggestedMax > 0 && !loadingcar"
              >
                <BarChart :chart-data="barchart" :options="BarChartOptions" />
              </div>
              <div v-if="loadingcar">
                <OverlayButton
                  clase="overlay-md"
                  style="opacity: 0.6"
                ></OverlayButton>
              </div>
              <div v-if="this.suggestedMax == 0 && !loadingcar">
                <p class="col-12 text-center my-2 cta-small">
                  Sin datos para mostrar.
                </p>
              </div>
            </b-col>
            <b-col md="7" v-if="user.core_role_id != 18">
              <template>
                <div>
                  <div class="d-flex">
                    <div class="align-items-center ChangeTypeGES">
                      <button
                        class="mt-0 mr-1 p-0 d-flex align-items-center"
                        :disabled="isDisabledO"
                        @click="changeTable('opt')"
                        :class="{
                          ges_active: activeBtn === 'opt',
                          ges_inactive: activeBtn === 'adm',
                        }"
                      >
                        <p class="mb-0 d-none d-lg-block cta">Operativos</p>
                      </button>

                      <button
                        class="ml-0 mt-0 p-0 d-flex align-items-center"
                        :disabled="isDisabledA"
                        @click="changeTable('adm')"
                        :class="{
                          ges_active: activeBtn === 'adm',
                          ges_inactive: activeBtn === 'opt',
                        }"
                      >
                        <p class="mb-0 d-none d-lg-block cta">
                          Administrativos
                        </p>
                      </button>
                    </div>

                    <div
                      style="
                        width: 100%;
                        display: flex;
                        justify-content: end;
                        top: 12px;
                        position: relative;
                      "
                    >
                      <router-link
                        to="/sve/GES"
                        class="small-flat"
                        style="font-weight: bold"
                      >
                        Ver más
                      </router-link>
                    </div>
                  </div>

                  <b-table
                    :items="dataTable.rows"
                    :fields="dataTable.fields"
                    :busy="loading"
                    select-mode="single"
                    class="col-12 mt-2 table-views text-center"
                  >
                    <template #cell(type)="row">
                      <span
                        class="status"
                        :style="
                          'color:' +
                          row.item.type.textcolor +
                          ';padding: 10px;border-radius: 8px;border: 1px solid ' +
                          row.item.type.color
                        "
                      >
                        <img
                          v-if="row.item.type.icon"
                          class="centerImg1 mr-1"
                          :src="
                            require('@/assets/images/icons/' +
                              row.item.type.icon)
                          "
                          width="20px"
                        />

                        {{ row.item.type.text }}
                      </span>
                    </template>
                    <template #table-busy>
                      <div class="text-center my-2 mb-3">
                        <OverlayButton
                          clase="overlay-md"
                          opacity="0.6"
                        ></OverlayButton>
                      </div>
                    </template>
                  </b-table>
                  <div
                    class="col-12 cont-pagination my-5 d-flex justify-content-center"
                  >
                    <Pagination
                      :data="tableGES"
                      :limit="15"
                      @pagination-change-page="loadRowsPag"
                    ></Pagination>
                  </div>
                  <div v-if="!this.dataTable.rows[0] && !loading">
                    <p class="my-2 cta-small">Sin datos para mostrar.</p>
                  </div>
                </div>
              </template>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import DoughnutChart from "@/components/charts/DoughnutChart";
import BarChart from "@/components/charts/BarChart";
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import OverlayGeneral from "@/components/core/overlay/overlay-general.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "Management",
  components: {
    BarChart,
    DoughnutChart,
    MainBarMenuV2,
    HeadingUser,
    Pagination,
    OverlayButton,
    OverlayGeneral,
    Multiselect,
    htDetailsArea: () =>
      import("@/components/healthTracker/Ges/V2/DetailsArea/HTDetailsArea.vue"),
    HeaderV2: () => import("@/components/common/header/HeaderV2.vue"),
    ProgressBar: () => import("@/components/progress/ProgressBar"),
  },
  data() {
    return {
      dataTable: {
        rows: [],
        fields: [],
        page: 1,
        activeBtn: "opt",
        isDisabledA: false,
        isDisabledO: true,
      },
      dataTableAdm: {
        rows: [],
        fields: [],
      },
      dataTableOper: {
        rows: [],
        fields: [],
      },
      dataTablePandA: {
        rows: [],
        fields: [],
      },
      Select_SveDash_Oha: [],
      Selected_SveDash_Oha: [],
      data_users: [],
      data_users_string: [],
      TotalratingGes: 0,
      TotalratingGesOper: 0,
      TotalratingGesAdm: 0,
      tableRiskadministrative: [],
      tableRiskoperative: [],
      tableRiskadm_high: 0,
      tableRiskadm_medium: 0,
      tableRiskadm_low: 0,
      tableRiskadm_List: [],
      tableRiskoper_high: 0,
      tableRiskoper_medium: 0,
      tableRiskoper_low: 0,
      tableRiskoper_List: [],
      verarea: false,
      suggestedMax: 0,
      area_id: "",
      area_name: "",
      SVEtemp: {
        id: 0,
        name: "",
      },
      dataSvePercent: [],
      typeGes: "",
      ratingGes: {
        labels: ["Administrativos", "Operativos"],
        datasets: [
          {
            backgroundColor: ["#FF9900", "#5D5FEF"],
            data: [],
          },
        ],
      },
      ChartOptions: {
        responsive: true,
        cutoutPercentage: 70,
        innerRadius: "75%",
        cornerRadius: 20,
        borderRadius: 40,
        legend: {
          display: false,
        },
      },
      barchart: {
        labels: ["Alto", "Medio", "Bajo"],
        datasets: [
          {
            label: "Operativo",
            data: [0, 0, 0],
            backgroundColor: "#5D5FEF",
            borderRadius: 40,
            maxBarThickness: 30,
            innerRadius: "75%",
            cornerRadius: 20,
          },
          {
            label: "Administrativo",
            borderRadius: 40,
            maxBarThickness: 30,
            data: [0, 0, 0],
            backgroundColor: "#FF9900",
            innerRadius: "75%",
            cornerRadius: 20,
          },
        ],
      },
      BarChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 18,
                fontStyle: "bold",
                fontColor: "#263238",
                suggestedMax: 50,
                padding: 10,
              },
              gridLines: {
                drawOnChartArea: false,
                color: "rgba(0,0,0,1)",
                drawTicks: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                suggestedMax: 0,
                padding: 10,
              },
              gridLines: {
                drawOnChartArea: false,
                color: "rgba(0,0,0,1)",
                drawTicks: false,
              },
            },
          ],
        },
      },
      currentNameSve: "",
    };
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modSVE", [
      "loading",
      "error",
      "message",
      "tableGES",
      "ges",
      "sveList",
    ]),
    ...mapState("modSVEMnet", [
      "loadingOn",
      "loadingarea",
      "loadingcl",
      "loadingcar",
      "loadingFiltro",
      "loadingPandA",
      "error",
      "message",
      "SveDash",
      "SveDash_id",
      "SveDash_cl",
      "SveDash_percent",
      "SveDash_char",
      "SveDashPandA",
      "SveDash_Oha",
    ]),
  },
  beforeMount() {
    this.typeGes = "operative";
    this.isDisabledA = false;
    this.isDisabledO = true;
    this.activeBtn = "opt";
    let data = {
      type: this.typeGes,
    };
    this.verarea = false;
    this.currentNameSve = "";
    if (this.user.core_role_id == 18) this.actGetSveGesOha();
    this.LoadInit();
    if (this.user.core_role_id != 18) this.loadRows(data);
  },
  methods: {
    ...mapActions("modCore", ["actUserLocalStorage"]),
    ...mapActions("modSVE", ["actGetGESTable"]),
    ...mapActions("modSVEMnet", [
      "actGetSveDash",
      "actGetSveGesDash",
      "actGetSveGesClDash",
      "actGetSvePercDash",
      "actGetSveDash_Char",
      "actSveDashPandA",
      "actGetSveGesOha",
    ]),
    Selected_user() {
      const me = this;
      const data = {};
      // this.data_users = [];
      me.Selected_SveDash_Oha.forEach((x, index) => {
        data[`locations[${index}]`] = x?.id
      });

      // let data = "";
      // for (let i = 0; i < this.data_users.length; i++) {
      //   data +=
      //     "users[" + i + "][id_users]=" + this.data_users[i].user_id + "&";
      //   data +=
      //     "users[" + i + "][id_location]=" + this.data_users[i].site_id + "&";
      // }
      this.verarea = false;
      // this.data_users_string = data;
      this.LoadInit(data);
    },
    loadRowsPag(page = 1) {
      let data = {
        type: this.typeGes,
        page: page,
      };
      this.loadRows(data);
    },
    VerAreaOperGesPag(page = 1) {
      let data = {
        id: this.area_id,
        page: page,
      };
      this.VerAreaOperGes(data);
    },
    VerAreaAdmGesPag(page = 1) {
      let data = {
        id: this.area_id,
        page: page,
      };
      this.VerAreaAdmGes(data);
    },
    changeTable(x) {
      this.page = 1;
      this.activeBtn = x;
      if (x == "adm") {
        this.typeGes = "administrative";
        this.isDisabledA = true;
        this.isDisabledO = false;
      } else {
        this.typeGes = "operative";
        this.isDisabledA = false;
        this.isDisabledO = true;
      }
      let data = {
        type: this.typeGes,
        page: this.page,
      };
      this.loadRows(data);
    },
    VerAreaOperGes() {
      /*let data = this.data_users_string;
            let id = data2.id;
            let page = data2.page;*/
      /*this.actGetSveGesDash({ data, id, page }).then(() => {

                this.dataTableOper.rows = []
                this.SveDash_id.data.operative.data.forEach((x) => {

                    this.dataTableOper.rows.push({
                        tipo: x.core_area.name,
                        cantidad: x.count_employees,


                    });
                });

            })*/
    },
    VerAreaAdmGes() {
      /*let data = this.data_users_string;
            let id = data2.id;
            let page = data2.page;*/
      /*this.actGetSveGesDash({ data, id, page }).then(() => {
                this.dataTableAdm.fields = [{
                        key: "tipo",
                        label: "Administrativo",
                    },
                    {
                        key: "cantidad",
                        label: "Cantidad",
                    },

                ]

                this.dataTableAdm.rows = [];
                this.SveDash_id.data.administrative.data.forEach((x) => {
                    this.dataTableAdm.rows.push({
                        tipo: x.core_area.name,
                        cantidad: x.count_employees,


                    });
                });


            })*/
    },
    VerAreaGes({ id, name }) {
      // let data2 ={
      //   ges_id:id,
      //   code_type_ges:'administrative'
      // }
      this.area_id = id;
      this.area_name = name;
      this.SVEtemp.id = id;
      this.SVEtemp.name = name;

      this.verarea = true;
      this.currentNameSve = name;
      // let data = this.data_users_string;
      /*this.actGetSveGesDash({ data, id, page }).then(() => {
                this.dataTableAdm.fields = [{
                        key: "tipo",
                        label: "Administrativo",
                    },
                    {
                        key: "cantidad",
                        label: "Cantidad",
                    },

                ]

                this.dataTableAdm.rows = [];
                this.SveDash_id.data.administrative.data.forEach((x) => {
                    this.dataTableAdm.rows.push({
                        tipo: x.core_area.name,
                        cantidad: x.count_employees,


                    });
                });

                this.dataTableOper.fields = [{
                        key: "tipo",
                        label: "Operativo",
                    },
                    {
                        key: "cantidad",
                        label: "Cantidad",
                    },

                ]

                this.dataTableOper.rows = []
                this.SveDash_id.data.operative.data.forEach((x) => {

                    this.dataTableOper.rows.push({
                        tipo: x.core_area.name,
                        cantidad: x.count_employees,


                    });
                });

            })*/
    },
    async LoadInit(data) {
      const me = this;
      me.actGetSveDash(data);
      me.suggestedMax = 0;
      me.actGetSveGesClDash(data).then(() => {
        me.TotalratingGes =
          me.SveDash_cl.data.ges.administrative.count +
          me.SveDash_cl.data.ges.operative.count;
        me.TotalratingGesOper =
          (me.SveDash_cl.data.ges.operative.count * 100) /
          me.TotalratingGes;
        me.TotalratingGesAdm =
          (me.SveDash_cl.data.ges.administrative.count * 100) /
          me.TotalratingGes;
        me.ratingGes.datasets.data = [];
        me.ratingGes.datasets[0].data = [
          me.TotalratingGesAdm,
          me.TotalratingGesOper,
        ];
      });

      me.actGetSveDash_Char(data).then(() => {
        me.tableRiskadministrative =
          me.SveDash_char.data.ges.administrative;
        me.tableRiskadm_high = me.tableRiskadministrative.high_risk.count;
        me.tableRiskadm_medium =
          me.tableRiskadministrative.medium_risk.count;
        me.tableRiskadm_low = me.tableRiskadministrative.low_risk.count;
        me.tableRiskadm_List = [
          me.tableRiskadm_high,
          me.tableRiskadm_medium,
          me.tableRiskadm_low,
        ];
        me.tableRiskoperative = me.SveDash_char.data.ges.operative;
        me.tableRiskoper_high = me.tableRiskoperative.high_risk.count;
        me.tableRiskoper_medium = me.tableRiskoperative.medium_risk.count;
        me.tableRiskoper_low = me.tableRiskoperative.low_risk.count;
        me.tableRiskoper_List = [
          me.tableRiskoper_high,
          me.tableRiskoper_medium,
          me.tableRiskoper_low,
        ];

        me.barchart.datasets[1].data = me.tableRiskadm_List;
        me.barchart.datasets[0].data = me.tableRiskoper_List;
        const listmaxvalue = me.barchart.datasets[0].data.concat(
          me.barchart.datasets[1].data
        );
        me.BarChartOptions.scales.yAxes[0].ticks.suggestedMax = Math.max(
          parseInt(listmaxvalue)
        );

        var max = listmaxvalue.reduce(function (a, b) {
          return Math.max(a, b);
        }, -Infinity);
        me.suggestedMax = max;
      });

      me.actSveDashPandA(data).then(() => {
        me.dataTablePandA.fields = [
          {
            key: "Nivel",
            label: "Nivel de riesgo",
          },
          {
            key: "Alto",
            label: "Alto",
          },
          {
            key: "Medio",
            label: "Medio",
          },

          {
            key: "Bajo",
            label: "Bajo",
          },

          {
            key: "SinEval",
            label: "Sin evaluación",
          },
          {
            key: "Total",
            label: "Total",
          },
        ];

        me.dataTablePandA.rows = [];
        me.dataTablePandA.rows.push({
          Nivel: me.SveDashPandA.data.risk_level_worker_classification,
          Alto: me.SveDashPandA.data.high_risk,
          Medio: me.SveDashPandA.data.medium_risk,
          Bajo: me.SveDashPandA.data.low_risk,
          SinEval: me.SveDashPandA.data.no_evaluation,
          Total: me.SveDashPandA.data.total,
        });
      });
    },
    async loadRows(data) {
      this.actGetGESTable(data).then(() => {
        this.dataTable.fields = [
          {
            key: "name",
            label: "Nombre del GES",
          },
          {
            key: "people",
            label: "Total Personas",
          },
        ];

        this.dataTable.fields.push({
          key: "type",
          label: "Caracterización del GES",
        });

        this.dataTable.rows = [];
        this.tableGES.data.forEach((x) => {
          let status = {};
          switch (x.characterization_code) {
            case null:
              status = {
                color: "#5D5FEF",
                textcolor: "#5D5FEF",
                text: "Realizar riesgo potencial",
                id: x.id,
              };
              break;
            case "":
              status = {
                color: "#5D5FEF",
                textcolor: "#5D5FEF",
                text: "Realizar riesgo potencial",
                id: x.id,
              };
              break;
            case "Riesgo bajo":
              status = {
                textcolor: "#0C9E42",
                icon: "riesgobajo.svg",
                text: x.characterization_code,
                id: x.id,
              };
              break;
            case "Riesgo medio":
              status = {
                textcolor: "#FF9900",
                icon: "warning_orange.svg",
                text: x.characterization_code,
                id: x.id,
              };
              break;
            case "Riesgo alto":
              status = {
                textcolor: "#DA1414",
                icon: "alarm-warning-line.svg",
                text: x.characterization_code,
                id: x.id,
              };
              break;
            case "Por Definir en IPT":
              status = {
                color: "#FEFFC8",
                icon: "warning_red.svg",
                text: x.characterization_code,
                id: x.id,
              };
              break;

            default:
              break;
          }
          this.dataTable.rows.push({
            name: x.name,
            people: x.total_employees,
            diseases: x.total_diseases,
            type: status,
            sve: x.sve,
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.not-active {
  pointer-events: none;
  cursor: default;
}

.main-types-ges {
  ul {
    padding: 0;
    margin: 0;
  }
  li {
    margin-bottom: 10px;
  }
}

.title-graphics {
  display: inline-block;
  width: 40%;
  vertical-align: middle;
}

.types-ges-graphics {
  background-color: #ececff;
  border: 1px solid #ececff;
  border-radius: 8px;
  padding: 20px 8px;
  display: inline-block;
  width: 59%;
}

.box-area-ges {
  width: 100%;
  border-radius: 8px !important;
  box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 14%);
  min-height: 300px; //padding-top: 25%;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
}

.title-generic {
  font-size: 18px;
  font-weight: 700;
}

.subtitle-graphic {
  font-weight: 700;
  font-size: 16px;
  span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
  }
  .orange {
    background-color: #ff9900;
  }
  .blue {
    background-color: #5d5fef;
  }
}

.doughnut-chart-ges {
  position: relative;
  display: inline-block;
  width: 80%;
  margin: 0 auto;
  .percentage-chart-ges {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    font-size: 44px;
    font-weight: 700;
    text-align: center;
    transform: translate(0, -50%);
    line-height: 1;
    span {
      font-size: 16px;
      font-weight: 700;
      display: block;
    }
  }
}

.doughnut-main-ges {
  display: inline-block;
}

.doughnut-legend-ges {
  display: inline-block;
  width: 80%;
  margin: 0 auto;
  vertical-align: top;
  padding-top: 20px;
  li {
    margin-bottom: 15px;
  }
  .text-graphic {
    font-size: 12px;
    font-weight: 400;
    padding-left: 15px;
  }
}

.chartjs-render-monitor {
  height: 150px;
}

.high-risk-table {
  color: #da1414;
}

@media (min-width: 992px) {
  .doughnut-legend-ges {
    width: 55%;
  }
  .doughnut-chart-ges {
    width: 30%;
  }
}

.ges_inactive {
  border: 1px solid #c9caff !important;
  border-radius: 100px;
  padding: 8px 16px !important;
  border: 0 !important;
  border-radius: 50px !important;
  background: #ffffff;
  color: black;
  &:hover {
    background: #c9caff;
    border: 0 !important;
    border-radius: 50px !important;
    color: black;
  }
}

.ges_active {
  border: 0 !important;
  background-color: #5d5fef !important;
  border-radius: 50px;
  color: #ffffff !important;
  padding: 8px 16px !important;
}

.ChangeTypeGES {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px;
  gap: 4px;
  width: fit-content;
  background: #ffffff;
  margin-bottom: 24px;
  /* CTA/01 */
  border: 1px solid #c9caff;
  border-radius: 48px;
}

.Selected_area:hover,
.Selected_area_hover {
  background: #f7f7ff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  text-decoration: none;
}

// .area_link::after,.area_link::visited,.area_link:active{
// background: #F7F7FF !important;
// box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
// border-radius: 8px;
// text-decoration: none;
// }
</style>
